import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { MessageMediumTab } from 'modules/intelligentInsights/frequencyOptimization/types';
import {
  getMessageTypesByMedium,
  getMessageTypesForExport,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/breakdownUtils';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import { ConfigByMedium } from 'modules/frequencyManagement/lib/types';
import { addPositiveToast } from 'modules/toastContainer';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { downloadAsCsvFileWithHeaders } from 'utils/csv';
import { Export16 } from 'ui/icons';
import {
  EXPORT_CSV,
  BREAKDOWN_MESSAGE_TYPE_EXPORT_HEADERS,
  BREAKDOWN_MESSAGE_TYPE_EXPORT_SUCCESS,
} from 'modules/intelligentInsights/constants';
import { formatCsvFilenameWithDate } from 'modules/intelligentInsights/domain.utils';
import { TimespanEnum } from 'modules/intelligentInsights/types';

export type BreakdownExportCSVProps = {
  frmSettings: ConfigByMedium;
  messageMedium: MessageMediumTab;
};

const createLiftFileName = (timespan: TimespanEnum) => (formattedDateString: string) =>
  `froliftbymessagetype_${timespan}_days_${formattedDateString}.csv`;

export const BreakdownExportCSV: FC<BreakdownExportCSVProps> = ({ frmSettings, messageMedium }) => {
  const dispatch = useDispatch();
  const {
    froInsightsData,
    isLoading,
    timeSpan: { selectedTimespan },
  } = useFroInsightsCoreContext();

  const csvData = getMessageTypesForExport(
    getMessageTypesByMedium(froInsightsData, frmSettings, messageMedium),
  );
  const onDownloadCsv = () => {
    downloadAsCsvFileWithHeaders({
      headers: BREAKDOWN_MESSAGE_TYPE_EXPORT_HEADERS,
      data: csvData,
      fileName: formatCsvFilenameWithDate(createLiftFileName(selectedTimespan)),
    });
    dispatch(addPositiveToast(BREAKDOWN_MESSAGE_TYPE_EXPORT_SUCCESS));
  };

  return (
    <>
      {!isLoading && (
        <Button
          variant={BUTTON_VARIANTS.SECONDARY}
          size={BUTTON_SIZES.SMALL}
          onClick={onDownloadCsv}
        >
          <Export16 />
          {EXPORT_CSV}
        </Button>
      )}
    </>
  );
};
